import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FM005 {
  fm005_01: string;        // 處理代號 (PK, max 2 chars)
  fm005_11: string;        // 處理方式說明
  fm005_21: string;        // 建檔人員
  fm005_22: string | null; // 建檔日期
  fm005_91: string;        // 修改人員
  fm005_92: string | null; // 修改日期
}

export interface CreateRequest {
  fm005_01: string;
  fm005_11: string;
}

export interface UpdateRequest {
  fm005_11: string;
}

export interface ListResponse {
  data: FM005[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const invProcessApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/inv-process', { params });
    return res.data;
  },

  async get(code: string): Promise<FM005> {
    const res = await apiClient.get(`/api/inv-process/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FM005> {
    const res = await apiClient.post('/api/inv-process', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<FM005> {
    const res = await apiClient.put(`/api/inv-process/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/inv-process/${encodeURIComponent(code)}`);
  },
};
